/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RowGroup = {|
  id?: ?string,
  displayName?: ?string,
  field?: ?string,
|};
export type quotaOverviewQueryVariables = {|
  companyId: string,
  rowGroupCols?: ?$ReadOnlyArray<?RowGroup>,
|};
export type quotaOverviewQueryResponse = {|
  +Me: ?{|
    +Company: ?{|
      +Quotas: ?$ReadOnlyArray<?{|
        +id: string,
        +contract: {|
          +id: string,
          +date: ?any,
          +endDate: ?any,
          +tableId: number,
        |},
        +quota: ?{|
          +id: string,
          +name: ?string,
          +initCreditCache: ?number,
          +usedCreditCache: ?number,
          +unit: ?number,
          +quantity: ?number,
        |},
      |}>
    |}
  |}
|};
export type quotaOverviewQuery = {|
  variables: quotaOverviewQueryVariables,
  response: quotaOverviewQueryResponse,
|};
*/


/*
query quotaOverviewQuery(
  $companyId: ID!
  $rowGroupCols: [RowGroup]
) {
  Me {
    Company(id: $companyId) {
      Quotas(options: {rowGroupCols: $rowGroupCols}) {
        id
        contract {
          id
          date
          endDate
          tableId
        }
        quota {
          id
          name
          initCreditCache
          usedCreditCache
          unit
          quantity
        }
      }
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rowGroupCols"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "rowGroupCols",
          "variableName": "rowGroupCols"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "concreteType": "InvoiceItem",
  "kind": "LinkedField",
  "name": "Quotas",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Contract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tableId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Quota",
      "kind": "LinkedField",
      "name": "quota",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "initCreditCache",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usedCreditCache",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "quotaOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quotaOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "074d41cbc9e790bedf2bfda7702bbf3a",
    "id": null,
    "metadata": {},
    "name": "quotaOverviewQuery",
    "operationKind": "query",
    "text": "query quotaOverviewQuery(\n  $companyId: ID!\n  $rowGroupCols: [RowGroup]\n) {\n  Me {\n    Company(id: $companyId) {\n      Quotas(options: {rowGroupCols: $rowGroupCols}) {\n        id\n        contract {\n          id\n          date\n          endDate\n          tableId\n        }\n        quota {\n          id\n          name\n          initCreditCache\n          usedCreditCache\n          unit\n          quantity\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6cc76d14c62fca58c0e9a88acd23c1e8';

module.exports = node;
